import {useAtomValue} from 'jotai';
import {memo, useEffect, useState} from 'react';
import {BusStopData, MarkersLayerProps} from '@/map/@types';
import {useNearbyBusStation} from '@/map/api';
import {nearbyInfoAtom} from '@/map/atom';
import {MARKER_COUNT_LIMIT} from '@/map/constants';
import {AreaAnalyticsFilter} from '@/map/enums';
import {convertToCoordFromPointCoords} from '@/map/utils';
import {BusStopMarker} from '../../Markers/NearbyMarker';

const getList = (data?: BusStopData[]) => {
  const draft: BusStopData[] = [];

  if (!data) {
    return draft;
  }

  data.forEach((i) => {
    const index = draft.findIndex(
      (j) =>
        i.stopName === j.stopName &&
        i.avgNumberOfRidesPerDay === j.avgNumberOfRidesPerDay
    );

    if (index === -1) {
      const coords = i?.location?.coordinates;
      const point = convertToCoordFromPointCoords(coords);
      const item = {...i};

      if (point) {
        item.position = point;
      }

      draft.push(item);
    }
  });

  return draft;
};

export const BusStopLayer = memo(({map, bounds}: MarkersLayerProps) => {
  const {selected} = useAtomValue(nearbyInfoAtom);
  const isActive = selected.includes(AreaAnalyticsFilter.BUS);
  const [list, setList] = useState<BusStopData[]>([]);

  const {data} = useNearbyBusStation(
    isActive && bounds
      ? {
          limit: MARKER_COUNT_LIMIT,
          ...bounds,
        }
      : undefined
  );

  useEffect(() => {
    if (data?.length) {
      setList((prev) => {
        return getList([
          ...prev.filter(
            (i) => i.position && map.getBounds().hasPoint(i.position)
          ),
          ...data.slice(0, MARKER_COUNT_LIMIT),
        ]);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  if (!isActive || !list?.length) {
    return null;
  }

  return (
    <>
      {list.map(
        (i, idx) =>
          !!i.position && (
            <BusStopMarker
              key={idx + i.stopName + i.position.toString()}
              map={map}
              position={i.position}
              item={i}
            />
          )
      )}
    </>
  );
});
